import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TitleBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'robotoLight', sans-serif;
  color: #000;

  h1 {
    font-size: 60px;
    line-height: 72px;
    margin: 0;
  
    @media only screen and (max-width: 1919px) {
      font-size: 44px;
      line-height: 56px;
    }
  
    @media only screen and (max-width: 1023px) {
      font-size: 32px;
      line-height: 40px;
    }
  
    @media only screen and (max-width: 767px) {
      font-size: 24px;
      line-height: 30px;
    }
  }

  h2 {
    font-size: 44px;
    line-height: 56px;
    margin: 0;
  
    @media only screen and (max-width: 1919px) {
      font-size: 32px;
      line-height: 40px;
    };
  
    @media only screen and (max-width: 767px) {
      font-size: 24px;
      line-height: 30px;
    };
  }

  h3 {
    font-size: 32px;
    line-height: 40px;
    margin: 0;
  
    @media only screen and (max-width: 767px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
`;

const Description = styled.p`
  width: 47%;
  margin: 0 auto;
  margin-top: 17px;
  text-align: center;
  font-family: 'robotoLight', sans-serif;
  font-size: 20px;
  line-height: 28px;

  @media only screen and (max-width: 1919px) {
    width: 66%;
    font-size: 16px;
    line-height: 24px;
    margin-top: 20px;
  }

  @media only screen and (max-width: 1365px) {
    width: 76%;
  }

  @media only screen and (max-width: 1023px) {
    width: 69%;
    margin-top: 15px;
  }

  @media only screen and (max-width: 767px) {
    width: 85%;
    margin-top: 20px;
  }
`;

const Text = styled.p`
  width: 100%;
  margin: 0 auto;
  margin-top: 18px;
  text-align: center;
  font-family: 'robotoLight', sans-serif;
  font-size: 20px;
  line-height: 28px;

  @media only screen and (max-width: 1365px) {
    margin-top: 25px;
  }

  @media only screen and (max-width: 767px) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 19px;
  }
`;

export default class Title extends Component {
  static propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    as: PropTypes.string,
    description: PropTypes.string,
  };

  render() {
    const { title, as, description, text, className } = this.props;

    const TitleText = as;

    const Title = <TitleText>{title}</TitleText>;
    let Desc = description ? <Description>{description}</Description> : null;

    if (text && !description) {
      Desc = <Text>{text}</Text>;
    }

    return (
      <TitleBlock className={className}>
        { Title }
        { Desc }
      </TitleBlock>
    );
  }
}
